import { ApiError } from '@/shared/api/client';

/**
 * Server integrity-gate codes returned when a line's discount / regalo /
 * campaña claim no longer matches the live configuration — typically
 * because an admin edited the rules (a bracket %, a monthly limit, a gift
 * minimum, a campaign) while the seller had the cotización open, so the
 * browser's cached params were stale at submit.
 *
 * The cotización screens treat these specially: refetch the reference data
 * so the form re-evaluates against the new config (the flagged line then
 * shows it needs approval / a motivo), and tell the seller to review and
 * resubmit — instead of the generic "try again later" that wouldn't help
 * (the stale cache would just fail again).
 */
export const STALE_CONFIG_CODES = new Set<string>([
  'descuento_invalido',
  'regalo_monto_minimo',
  'regalo_no_accesorio',
  'regalo_cupo_mensual',
  'campania_invalida',
]);

/** The ApiError when it's a stale-config gate rejection, else null. */
export function staleConfigError(err: unknown): ApiError | null {
  return err instanceof ApiError && STALE_CONFIG_CODES.has(err.code) ? err : null;
}

/** User-facing copy: the specific server reason + a refresh note. */
export function staleConfigMessage(err: ApiError): string {
  const base = err.message?.trim();
  const note =
    'Se actualizaron las reglas de descuentos/regalos. Revisá las líneas marcadas y volvé a confirmar.';
  return base ? `${base} ${note}` : note;
}
